<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)" srcset="assets/img/admission-desktop-banners/How-To-Apply.webp">
        <source media="(min-width:768px)" srcset="assets/img/admission-desktop-banners/medium-screen/how-to-apply.webp">
        <img
            src="assets/img/admissions-mobile-banners/how-to-apply.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-[950px] lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Applying to ARNI</h2>
                    <div>
                        <a
                            href="/admissions/overview"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive('/admissions/overview'),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive('/admissions/overview')
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-y border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Overview</span>
                        </a>

                        <a
                            *ngFor="let link of [
            { href: '/admissions/campus-virtual-tour', label: 'Campus Virtual Tour' },
            { href: '/admissions/criteria', label: 'Admission Criteria' },
            { href: '/admissions/flow', label: 'Admission Flow' },
            { href: '/admissions/program-fee', label: 'Program Fees' },
            { href: '/admissions/hostel-fee', label: 'Accommodation & Hostel' },
            { href: '/admissions/transportation-fee', label: 'Transportation Services' },
            { href: '/admissions/scholarship', label: 'Scholarship Opportunities' },
            { href: '/admissions/innovative-idea-scholarship', label: 'Innovative Idea Grants' },
            { href: '/admissions/fee-structure-for-previous-year-students', label: 'Fee Structures for Previous Year Students' },
            { href: '/admissions/education-loan-assistance', label: 'Education Loan Support' },
            { href: '/admissions/how-to-apply', label: 'How to Apply' },
            { href: '/quick-links/contact-us', label: 'Counseling Services' },
            { href: '/admissions/payment-procedure', label: 'Payment Procedure' },
            { href: '/admissions/refund-policy', label: 'Refund Policy' },
            { href: '/admissions/avenues-for-success', label: 'Avenues for Success@ARNI' },
            { href: '/admissions/lateral-entry-or-migration', label: 'Lateral Entry/Migration' },
            { href: '/admissions/faqs', label: 'FAQs' }
          ]"
                            [href]="link.href"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive(link.href),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive(link.href)
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-b border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ link.label }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </aside>

        <section class="flex-1 shadow-lg p-8 border-2 border-gray-200 h-fit bg-white aarni-font">
            <h2 class="text-2xl font-bold mb-4">How to Apply</h2>
            <div class="w-full mx-auto my-4">
                <div class="border-b border-gray-100 w-full">
                    <div class="border-b">
                        <button
                            class="w-full flex justify-between items-center p-2 text-left font-semibold text-lg my-2"
                            (click)="toggleAccordion(0)"
                        >
                            <span>Online Mode Recommended for Fast Track Registration</span>
                            <i [class]="activeIndex === 0 ? 'fa fa-angle-up text-2xl' : 'fa fa-angle-down text-2xl'"></i>
                        </button>
                        <div *ngIf="activeIndex === 0" class="p-6 bg-white">
                            <section class="flex-1 p-4 h-fit bg-white aarni-font">
                                <div class="flex flex-wrap justify-start gap-4 mb-6 relative">
                                    <div
                                        *ngFor="let step of steps; let i = index"
                                        (click)="activeStep = i"
                                        class="relative w-20 h-20 sm:w-16 sm:h-16 flex items-center justify-center border-2 rounded cursor-pointer text-sm text-center"
                                        [ngClass]="{
      'bg-[#029c83] text-white border-[#029c83]': activeStep === i,
      'bg-white text-gray-800 border-gray-300': activeStep !== i
    }"
                                    >
                                        Step {{ i + 1 }}
                                        <div
                                            *ngIf="activeStep === i"
                                            class="absolute bottom-[-12px] md:bottom-[-8px] left-1/2 -translate-x-1/2 w-0 h-0
         border-l-[10px] border-r-[10px] border-t-[10px]
         border-l-transparent border-r-transparent border-t-[#029c83]"
                                        ></div>
                                    </div>
                                </div>
                                <div class="p-4 bg-[#f2f2f2] text-gray-700 min-h-[100px]"
                                     [innerHTML]="steps[activeStep].content"></div>
                            </section>

                        </div>
                    </div>
                    <div class="border-b">
                        <button
                            class="w-full flex justify-between items-center p-2 text-left font-semibold text-lg my-2"
                            (click)="toggleAccordion(1)"
                        >
                            <span>Offline Mode</span>
                            <i [class]="activeIndex === 1 ? 'fa fa-angle-up text-2xl' : 'fa fa-angle-down text-2xl'"></i>
                        </button>
                        <div *ngIf="activeIndex === 1" class="p-8 bg-white">
                            <div class="p-4 bg-[#f2f2f2] text-gray-700 min-h-[100px]">
                                <ul class="list-disc pl-6">
                                    <li>Visit the University In-Person</li>
                                    <li> Fill out the form on the spot
                                    </li>
                                    <li>Immediate Guidance
                                    </li>
                                </ul>
                                <p>Walk-In Option Available:</p>
                                <p>Visit the Admission Desk at ARNI University – We're here to help
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center py-8">
                    <button class="bg-green-500 text-white px-14 py-2 md:ml-6 rounded-3xl font-semibold w-fit"
                            (click)="goTo('/form/apply-form')">
                        Apply Now
                    </button>
                </div>
            </div>
        </section>

    </div>

</div>
